import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { FormAnuncio } from "../../componente/Anuncio/FormAnuncio"
import { GetVoidAnunciosData } from "../../types/Anuncio/AnuncioData";
import { useEffect, useState } from "react";
import AnuncioService from "../../services/AnuncioService";
import { useParams } from "react-router-dom";
import { NoEditPage } from "../../componente/Error/NoEdit";
import { themePalette } from "../../config/theme.config";


export const EditAnuncioPage: React.FC<{}> = () => {
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [anuncio, setAnuncio] = useState(GetVoidAnunciosData());
    const [status, SetStatus] = useState(0);
    //Function
    const MiAnuncio = (id: number) => {
        setLoading(true);
        AnuncioService.GetMiAnuncio(id)
            .then((resp) => {
                if (resp.status.isSuccessfully) {
                    setAnuncio(resp.data || GetVoidAnunciosData())
                    SetStatus(resp.statusCode);
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                setLoading(false);
            })
    }
    //Effect
    useEffect(() => {
        MiAnuncio(parseInt(id ?? '0', 10));
    }, [])
    return (
        <Container maxWidth="lg" style={{ border: `1px solid ${themePalette.NAVCOLOR}`, borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center', marginTop: 10 }}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                Editar Comunicado
            </Typography>
            <Box sx={{ display: 'flex', m: 2 }}>

                {loading ? (
                    <CircularProgress />
                ) : (
                    status === 200
                        ? <FormAnuncio anuncio={anuncio} />
                        : <NoEditPage messages={['Usted no es el creador del anuncio al que intenta acceder.', 'Tal vez el anuncio al que intenta acceder está eliminado.']} />
                )}
            </Box>
        </Container>
    );
};